module.exports = __webpack_public_path__ + "static/media/depositar_voto.6e645b92.svg";